module.exports = [   
    {
      id: "contactOwner",
      fieldName: "Contact Owner",
    }, 
    {
      id: "insuranceLeadSource",
      fieldName: "Insurance LeadSource",
    }, 
    {
      id: "lastName",
      fieldName: "Last Name",
    }, 
    
    {
      id: "email",
      fieldName: "Email",
    } 
]